import React, { useEffect, useState } from 'react'

import { parseDuration } from 'util/datetime'
import { endOfWeek, formatISO, startOfWeek, } from "date-fns"

import { usePerfil } from 'useAuth'
import { useForm } from 'react-final-form'
import { getClient, getTipoPerfil, listaAgrupadores, requiredMsgFunc, getQuery, filterSnapshot, prepareFilterData, filterValidation } from './functions'
import { listaIndicadores } from './listaIndicadores'

import FilterTitle from './FilterTitle'
import SeletorMultiploClientes from './SeletorMultiploClientes'
import SeletoresData from './SeletoresData'
import SeletorFazenda from 'entity/Fazenda/components/SeletorFazenda'
import SeletorIndicadorAgrupado from './SeletorTipoIndicador'
import SeletorTecnico from 'entity/Cliente/components/SeletorTecnico'
import BotoesFiltro from './BotoesFiltro'

import DefaultCrudForm from 'components/form/DefaultCrudForm'
import FormContent from 'components/form/FormContent'
import FormRow from 'components/form/FormRow'
import SelectInput from 'components/form/input/SelectInput'

import { Accordion, AccordionDetails } from '@mui/material'
import { DebugConsole, DebugSetVisita } from './Debugg'

import { MenuItem } from "@mui/material"

const agrupadoresRel = listaAgrupadores()
let indicadoresPossiveis = listaIndicadores()
const ativaInicializadorTeste = false

function FiltrosInter(props) {
    const { laudos, setLaudos, apontamentosPorTipo, setApontamentosPorTipo, setGlobalLoading, values: filters } = props
    const [msgFilter, setMsgFilter] = useState("")
    const [filtersOld, setFiltersOld] = useState(filters)
    const [tecnicosPossiveis, setTecnicosPossiveis] = useState([])
    const form = useForm()
    const perfil = usePerfil()
    const [tipoPerfil, setTipoPerfil] = useState('cliente')

    useEffect(() => { getTipoPerfil(perfil, setTipoPerfil) }, [perfil]) /* tecnico, admin ou cliente*/

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { setLaudos([]) }, [])

    useEffect(() => {
        prepareFilterData(laudos, filters.cliente, tipoPerfil, filters.tiposIndicador, indicadoresPossiveis, agrupadoresRel, filters.agrupador, parseDuration, setApontamentosPorTipo)
        return () => { }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [laudos, filters.cliente, setApontamentosPorTipo,])

    useEffect(() => {
        filterValidation(() => { props.form.change("tecnico", "") }, setMsgFilter, setGlobalLoading, filtersOld.cliente, setFiltersOld, filters, filterOnClick)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.cliente, filters.dataInicio, filters.dataFim, filters.fazenda, filters.tiposIndicador, filters.agrupador, filters.tecnico,])

    const filterOnClick = () => {
        let observer = null

        if ((getClient(filters.cliente) || tipoPerfil === 'admin') && filters.dataInicio && filters.dataFim) {
            setMsgFilter("")
            setGlobalLoading("Buscando Laudos")

            let query = getQuery(filters.cliente, filters.fazenda, filters.tecnico, filters.dataInicio, filters.dataFim)

            observer = query.onSnapshot(
                async (qs) => { filterSnapshot(qs, ativaInicializadorTeste, filters.tiposIndicador, filters.cliente, filtersOld.cliente, setTecnicosPossiveis, setLaudos, setGlobalLoading) },
                (err) => { console.error(`error: ${err}`) }
            )
        } else {
            setLaudos(["Informe "]);
            requiredMsgFunc(getClient(filters.cliente), filters.dataInicio, filters.dataFim, () => props.form.change("tecnico", ""), setMsgFilter, setGlobalLoading)
        }

        return () => {
            if (observer) observer()
        }
    }

    return (
        <Accordion sx={{ flex: 1 }}>
            <FilterTitle cliente={filters.cliente} dataInicio={filters.dataInicio} dataFim={filters.dataFim} />
            <AccordionDetails>
                <FormContent sx={{ p: 1, display: "flex", justifyContent: "center", flexWrap: 'wrap' }}>
                    <FormRow>
                        <DebugSetVisita change={form.change} filters={filters} />
                        <DebugConsole values={filters} />
                    </FormRow>
                    <FormRow>
                        <SeletorMultiploClientes agrupador={filters.agrupador} cliente={filters.cliente} change={props.form.change} perfil={perfil} setTipoPerfil={setTipoPerfil} tipoPerfil={tipoPerfil} />
                        <SeletoresData change={props.form.change} />
                    </FormRow>
                    <FormRow>
                        <SeletorFazenda sx={{ flex: 1 }} fieldFilterAdd={"cliente.nome"} cliente={filters.cliente && filters.cliente.length ? filters.cliente[0] : {}} disabled={filters.cliente && filters.cliente.length === 1 ? false : true} /* habilitado somente com um cliente */ />
                    </FormRow>
                    <FormRow>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 15, flex: 4, flexWrap: 'wrap' }}>
                            <SeletorIndicadorAgrupado change={form.change} indicadoresPossiveis={indicadoresPossiveis} />
                            <SeletorTecnico possiveis={tecnicosPossiveis} disabled={tecnicosPossiveis.length && filters.dataInicio && filters.dataFim && filters.cliente && filters.cliente.length === 1 ? false : true} />
                            <SelectInput name="agrupador" label="Agrupador" permiteLimpar>
                                {agrupadoresRel.map((agrup) => (
                                    <MenuItem
                                        key={agrup.nome}
                                        value={agrup.nome}
                                        disabled={
                                            agrup.param.includes('cliente')
                                                ? tipoPerfil === 'admin'
                                                    ? filters.cliente && filters.cliente.length && filters.cliente.length === 1
                                                        ? true // desabilita opção, porque só tem um cliente selecionado
                                                        : false // mais de um cliente selecionado e o usuário é admin
                                                    : true // quando o usuário não é admin, bloqueia a opção de agrupar por Cliente
                                                : false // não é a opção p/ agrupar "Cliente", então deixa habilitado (pode ser a opção Frente, ou Turno, Equipamento, Talhão, etc)
                                        }
                                    >
                                        {agrup.nome}
                                    </MenuItem>
                                ))}
                            </SelectInput>

                        </div>
                        <SelectInput sx={{ flex: 1 }} name="detalhaApontamentos" label="Detalha Apontamentos" options={["Sim", "Não"]} />
                    </FormRow>

                    <BotoesFiltro filterOnClick={filterOnClick} laudos={laudos} apontamentosPorTipo={apontamentosPorTipo} filters={filters} agrupadoresRel={agrupadoresRel} msgFilter={msgFilter} />
                </FormContent>
            </AccordionDetails>
        </Accordion>
    )
}

export default function Filtros(props) {
    let dateRef = new Date()
    const di = startOfWeek(dateRef, { weekStartsOn: 0 })
    const df = endOfWeek(dateRef, { weekStartsOn: 0 })

    return (
        <DefaultCrudForm
            sxForm={{}}
            initialValues={{ tipo: "Perdas", detalhaApontamentos: "Não", dataInicio: formatISO(di, { representation: "date" }), dataFim: formatISO(df, { representation: "date" }) }}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
        >
            {(propsForm) => { return <FiltrosInter {...props} {...propsForm} /> }}
        </DefaultCrudForm>
    )
}
